import { create } from 'zustand';
import { DatabaseEvent } from '@/types/event';
import { webSocketService, WSMessageType } from '@/services/websocket';

const MAX_LIVE_DATABASE_EVENTS = 100;

interface DatabaseEventsState {
    recentDatabaseEvents: DatabaseEvent[];
    addDatabaseEvent: (databaseEvent: DatabaseEvent) => void;
    removeDatabaseEventsBySourceId: (sourceId: string) => void;
}

export const useDatabaseEventsStore = create<DatabaseEventsState>((set) => ({
    recentDatabaseEvents: [],

    addDatabaseEvent: (databaseEvent) =>
        set((state) => {
            const exists = state.recentDatabaseEvents.some(
                (existing) => existing.id === databaseEvent.id,
            );
            if (exists) return state;

            return {
                recentDatabaseEvents: [
                    databaseEvent,
                    ...state.recentDatabaseEvents,
                ].slice(0, MAX_LIVE_DATABASE_EVENTS),
            };
        }),

    removeDatabaseEventsBySourceId: (sourceId) =>
        set((state) => ({
            recentDatabaseEvents: state.recentDatabaseEvents.filter(
                (databaseEvent) => databaseEvent.event.sourceId !== sourceId,
            ),
        })),
}));

if (typeof window !== 'undefined') {
    webSocketService.on<DatabaseEvent>(
        WSMessageType.DATABASE_EVENT,
        (databaseEvent) => {
            useDatabaseEventsStore.getState().addDatabaseEvent(databaseEvent);
        },
    );
}
